<script lang="ts">
	import type { Snippet } from 'svelte';

	let {
		children,
		noGap = false,
		style
	}: { children: Snippet; noGap?: boolean; style?: string } = $props();
</script>

<div {style} class:noGap>
	{@render children()}
</div>

<style lang="scss">
	div {
		@include blocksGrid;
	}

	.noGap {
		padding-top: 0;
	}
</style>
